// MAC manzilini bitta barqaror shaklga keltiradi — server tomonidagi
// `venue.internal.MacAddress.normalize` nusxasi (o'sha faylning javadoc'i:
// "MikroTik uni AA:BB:CC:DD:EE:FF shaklida yozadi, lekin portalga qurilma
// sahifasi orqali keladigan qiymat aa-bb-cc-dd-ee-ff yoki aabb.ccdd.eeff
// bo'lishi mumkin").
//
// ⚠️ Bu funksiya faqat TEKSHIRISH uchun (URL'dagi `mac` parametri
// haqiqatan MAC'ga o'xshaydimi — aks holda backendga so'rov yuborishning
// ma'nosi yo'q, mehmon "sahifa noto'g'ri ochilgan" xabarini darhol
// ko'rishi kerak). Serverga esa URL'dan kelgan XOM qiymat o'zgartirilmasdan
// yuboriladi — backend baribir qayta normallashtiradi, ikkinchi
// normalizatsiya faqat ikkita amalga oshiruv sirg'alib ketish (drift)
// xavfini qo'shardi.
export function looksLikeMac(raw: string): boolean {
  const hex = raw.replace(/[^0-9a-fA-F]/g, '')
  return hex.length === 12
}
